/* eslint-disable max-len */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import AnimatedList from '../../../../components/Animation/AnimatedList';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import { Auth } from 'aws-amplify';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Slugify } from '../../../../CommonMethods/Slugify';
import { FormattedNumber } from '../../../../CommonMethods/FormattedNumber';
import { CognitoData } from '../../../../CommonMethods/CognitoData';
import { async } from 'q';
import FormatDateString from '../../../../CommonMethods/FromatDateString';
const TableBody = ({lastIndex,tableData, indexNum, pageNumber,selectedIndex, setSelectedIndex, selectedRef, setConfirmationState, handleSidePopupClick,email }) => {
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const [userCognitoEmail, setUserCognitoEmail] = useState('');
    const [userType, setUserType] = useState('');
    const location=useNavigate();
    const [searchParams, setSearchParams] = useSearchParams('')

    /**
     * The function onClickActivation handles different actions based on the target id, such as viewing
     * data, resetting passwords, or activating/deactivating an item.
     */
    const onClickActivation = (e) => {
        e.preventDefault();
        setSelectedIndex(null);
        if(e.target.id === 'View') {
            setConfirmationState({item: tableData, view : true})
        } else if(e.target.id === 'Reset Password'){
            setConfirmationState({item: tableData, status: "Reset Password"})      
        }else
        {
            setConfirmationState({item: tableData, status: !tableData.status ? 'Activate' : 'Deactivate'})
        }
    }

    /**
    * The function `handleEditClick` redirects the user to the edit page for a specific institution
    * user based on their email address.
    */
    const handleEditClick = () => {
        location(`/manage-institution-users/edit/${tableData.email_address}?${searchParams.toString()}`)
    }

    /**
     * The function `handelActionButton` sets the selected index to the provided index number.
     */
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
    }

    /**
    * The function `getCurrentUserData` retrieves the current user's email from Cognito data and sets
    * it as the user's Cognito email.
    */
    const getCurrentUserData = async() => {
        const data = await CognitoData()
        setUserCognitoEmail(data.accessToken.payload.username)
        setUserType(data.idToken.payload["custom:user_type"])
    }

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case, it
    is used to call the `getCurrentUserData` function when the component mounts. The
    `getCurrentUserData` function retrieves the current user's email from Cognito data and sets it as
    the user's Cognito email. The empty array `[]` as the second argument to `useEffect` ensures that
    the effect is only run once, when the component mounts. */
    useEffect(() => {
        getCurrentUserData()
    }, []);

    const disable3Dots = tableData.user_type === 'institution-admin' && userType !== 'institution-admin';

    return (
        <>
            <AnimatedList
                cursorpointer
                rowStatus={tableData.status}
                keyItem={indexNum}
                title={'View Details'}
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        handleSidePopupClick('View', tableData)
                    }
                }}
                child={
                    <>
                        <td class={``}>
                            <span>{tableData.first_name}{" "}{tableData.last_name}</span>
                            {tableData.user_type==='institution-admin'&&
                            <><br/><span className={`flex justify-start insti-admin`}>Institution Admin</span></>}
                        </td>
                        <td class={`text-start`}>{tableData.email_address}</td>
                        <td class={`text-start`}>{FormattedNumber(tableData.mobile_number)}</td>
                        <td class={`text-start`}>{FormatDateString(tableData.created_at)}</td>
                        <td className="table-cell ">
                            <div className='flex justify-center'>
                                <div className={`rounded ${tableData.status ? 'bg-[#C5FFD5]' : 'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5 w-fit`}>
                                    <img loading="lazy" decoding="async" src={tableData.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                    <span className="text-f7 font-normal text-[#031624] pl-1">{tableData.status ? 'Active' : 'Inactive'}</span>
                                </div>
                            </div>
                            
                        </td>
                        <td className="text-start prevent-click">
                            <div className={`relative flex items-center justify-center prevent-click ${userType === 'institution-admin' && userCognitoEmail === tableData.email_address}" data-te-dropdown-ref `}>
                                <button type='button' className={`list-more-btn prevent-click ${disable3Dots} ${disable3Dots?"img-disable":""}`} href="#"
                                    id={tableData.email_address}
                                    disabled={disable3Dots}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() =>handelActionButton(indexNum) }
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" className='prevent-click'/>
                                </button>
                                {selectedIndex === indexNum && <ul ref={selectedRef} className={`list-more-optns-div ${(indexNum+3 >= 10) ? ((userCognitoEmail !== tableData.email_address) ? ( tableData.status?'top2':'top3') : 'top1') : ''} [&[data-te-dropdown-show]]:block`}
                                    aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                    {/* <li>
                                        <AnimatedButton  
                                            handleClick={()=>{}} 
                                            buttonName={"View"}
                                            link={`/manage-branches/${tableData._id}`}
                                            className="list-more-optns prevent-click"
                                        />
                                    </li> */}                                   
                                    <>
                                        <li title='View Details'>
                                            <AnimatedButton
                                                handleClick={() => { handleSidePopupClick('View', tableData) }}
                                                buttonName={"View Details"}
                                                className="list-more-optns prevent-click"
                                            />
                                        </li>
                                        {(userCognitoEmail !== tableData.email_address) && <><li title='Edit User'>
                                            {tableData.status && <AnimatedButton
                                                handleClick={handleEditClick}
                                                buttonName={"Edit User"}
                                                className="list-more-optns prevent-click" />}
                                        </li><li title={!tableData.status ? "Activate" : "Deactivate"}>
                                            {tableData.user_type !== 'institution-admin' && <AnimatedButton
                                                handleClick={(e) => onClickActivation(e)}
                                                buttonName={!tableData.status ? "Activate" : "Deactivate"}
                                                className="list-more-optns prevent-click" />}
                                        </li></>}

                                        {tableData.status && (
                                            <li title='Reset Password'>
                                                <AnimatedButton 
                                                    handleClick={onClickActivation} 
                                                    buttonName={"Reset Password"}
                                                    className="list-more-optns prevent-click"
                                                />
                                            </li>
                                        )}
                                    </>                                                                   
                                </ul>}
                            </div>
                        </td>
                    </>
                }/>
        </>
    );
}

export default TableBody;
